import { Suspense } from 'react';
import WaitlistPageClient from '../agent/waitlist/WaitlistPageClient';

function WaitlistPageLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center p-3 sm:p-4 md:p-6"></div>
  );
}

export default function WaitlistPage() {
  return (
    <Suspense fallback={<WaitlistPageLoading />}>
      <WaitlistPageClient />
    </Suspense>
  );
}
